import { CellPreparedEvent } from 'devextreme/ui/data_grid';
import { addConditionalClass } from './addContitionalClass';

export const validateDataField = (
  event: CellPreparedEvent,
  datafield: string
): boolean => {
  if (
    event &&
    event.rowType === 'data' &&
    event.column.dataField &&
    event.column.dataField === datafield
  ) {
    return true;
  }

  return false;
};

export const handleOnCellPrepared = (event: CellPreparedEvent): void => {
  const dataFields = ['plNav', 'varHis'];

  dataFields.forEach((field) => {
    if (validateDataField(event, field)) {
      const value = Number(event.data[field]);
      const element = event.cellElement;
      if (field === 'plNav' || field === 'varHis') {
        addConditionalClass({
          element,
          showCritical: event.data[field] <= 0,
        });
      }

      if (event.watch) {
        event.watch(
          () => event.data[field],
          () => addConditionalClass({ value, element })
        );
      }
    }
  });
};
